import React, { useState } from 'react';
import AnimatedSection from '../../Hook/Block';

import Huit_Lignes from "./8_Lignes.png";
import Optimisation from './Optimisaton_cout.png'; // ton nom d'origine
import Pro_Modifiable from './Pro_Modifiable.png';
import Interoperabilite from "./Interopérabilite.png";
import Astreinte from './Astrainte.png'; // ton nom d'origine
import useCountUp from '../../Hook/useCountUp';
import Experience from './Experience.png';
import TarifsSlide from '../../Hook/TarifsSlide';
import TarifsSection from '../../Hook/TarifSection';
import './style.css';
import { useNavigate } from "react-router-dom";
import New from '../../pages/Telephonie/FadeInTel/New.png';
import Old from '../../pages/Telephonie/FadeInTel/Old.png';
import ImageFadeSlider from '../../pages/Telephonie/FadeInTel/FadeInTel';
import SEO from '../../Hook/Seo';
import VideoPresentationTelephonie from './TelephonieVideo.mp4'
const TelephoneFixe = () => {
    const navigate = useNavigate();

    const clients2 = useCountUp(350, 2000);

    // état séparé pour chaque section
    const [openTarifs, setOpenTarifs] = useState({ fixe: false, mobile: false });

    return (
        <>
            <SEO
                title="Téléphonie IP entreprise – Standards & SVI | AM Services dans les Vosges"
                description="Installation et gestion de téléphonie IP/VoIP : standards, SVI, DECT, portabilité, formation utilisateurs dans les Vosges."
                path="/telephonie"
                keywords={["téléphonie IP", "VoIP PME", "standard", "SVI", "DECT", "Vosges", "Remiremont", "Épinal , Saint Etienne les Remiremonts , Val D'Ajol , Pouxeux , Arches  "]}
            />

            <div className="div_container">
                <h1 className="sr-only">Téléphonie IP d’entreprise : standards, SVI et DECT dans les Vosges</h1>
                <video
                    src={VideoPresentationTelephonie}
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="background-video"
                    aria-label="Vidéo de présentation des services AM Services"
                />
                <div className="info-hero-center-text">
                <h1 className="info-title">TELEPHONE FIXE</h1>
                <p className="info-lead">
                    Chez AMServices, votre téléphonie professionnelle est simple, fluide et connectée.
                </p>
                </div>
            </div>
            {/* === TELEPHONIE FIXE === */}
            <div id='fixe'>
                <AnimatedSection
                    sectionTitle="Téléphonie Fixe"
                    direction="right"
                    items={[
                        { img: Huit_Lignes, alt: "Huit_Lignes", title: "Jusqu'a 8 lignes simultanées", text: "Jusqu'a 8 appels par poste pour un service de qualité." },
                        { img: Pro_Modifiable, alt: "Standard Pro", title: "Un Standard pro 100% personnalisable", text: "De la TPE au centre d’appels, une solution téléphonique unique et performante" },
                        { img: Astreinte, alt: "Astreinte", title: "Astreinte et dépannage 24/7", text: "Téléphonie fiable avec support 24/7 et intervention rapide sur site." }
                    ]}
                    count={clients2}
                    countLabel="Clients satisfaits"
                />
            </div>

            <AnimatedSection
                direction="right"
                items={[
                    { img: Optimisation, alt: "Optimisation des coûts", title: "Optimisation des coûts", text: "Réduction des frais d'infrastructure, facturation claire et adaptée à la consommation." },
                    { img: Interoperabilite, alt: "Interopérabilité", title: "Interopérabilité et intégration", text: "Compatibilité avec outils métiers (CRM, ERP, Microsoft Teams, etc.) pour gagner en productivité." },
                    { img: Experience, alt: "Expérience client", title: "Expérience client améliorée", text: "File d'attente intelligente, statistiques d'appels, routage pour répondre plus vite et mieux aux appels." }
                ]}
                count={clients2}
                countLabel="Clients satisfaits"
            />

            <TarifsSection
                name="Fixe"
                label="les tarifs Fixe"
                sectionTitle="Nos forfaits Fixe"
                openTarifs={openTarifs}
                setOpenTarifs={setOpenTarifs}
                tarifs={[
                    { title: "1 ligne", description: "Prix pour un poste", price: "25,00€HT/par poste" },
                    { title: "5 lignes", description: "A partir de 5 postes", price: "19,74€HT/par poste" },
                    { title: "10 lignes", description: "A partir de 10 postes", price: "15,00€HT/par poste" },
                    { title: "20 lignes", description: "A partir de 20 postes et + ", price: "11,03€HT/par poste" },
                ]}
            />

            <div className='div_btn-telephones'>
                <div className="btn-telephones" onClick={() => navigate("/telephone")}>
                    Voir nos Téléphones
                </div>
            </div>

            {/* === TELEPHONIE MOBILE === */}

            {/* === FADE TEL === */}
            <div className="fadinetel">
                <h2 className='section-title'>
                    Le réseau téléphonique évolue — préparez-vous dès aujourd’hui
                </h2>
                <p>
                    Le réseau téléphonique RTC sera arrêté en 2028, mettant fin aux lignes analogiques classiques.
                    Notre solution de remplacement permet de conserver votre téléphone fixe sans Internet,
                    <strong> dès 29,00 € HT/mois</strong>, tout en assurant un service fiable et conforme aux nouveaux standards.
                </p>
                <ImageFadeSlider
                    oldImage={Old}
                    newImage={New}
                />
            </div>

        </>
    );
};

export default TelephoneFixe;
